/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable no-confusing-arrow */
/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useMemo, useState } from 'react';
import { CircularProgress, useMediaQuery, useTheme, MenuItem, Menu } from '@material-ui/core';

import DashboardCard from 'ui/DashboardCard/DashboardCard';
import MobileSubtitle from 'ui/MobileSubtitle/MobileSubtitle';
import NavigationTitle, { LayoutType } from 'ui/NavigationTitle/NavigationTitle';
import identity from 'utils/identity';
import Tabs from 'ui/Tabs/Tabs';
import Loader from 'ui/Loader/Loader';
import Button, { Themes as ButtonThemes, Sizes as ButtonSizes } from 'ui/Button/Button';
import Table from 'ui/Table/Table';
import TransactionDetails from 'components/modals/TransactionDetails/TransactionDetails';
import { ITransactionField } from 'ui/structure/TransactionCard';
import { getTransactionsArray } from 'utils/mapping/transactionCardMapper';
import api from 'api/api';
import { IApiResponse } from 'utils/models';
import saveByteArray from 'utils/downloadAdvice';
import WarningModal from 'components/modals/WarningModal/WarningModal';
import PaymentAdviceModal from 'components/modals/PaymentAdviceModal/PaymentAdviceModal';
import NoData from 'ui/structure/NoData/NoData';
import TablePagination from 'ui/TableInputs/TablePagination/TablePagination';
import allColumns from './columns';
import {
  IApiTransactionReport,
  ITransactionReport,
  ITransactionReportMap,
  ITransactionReportSearchParams,
  InnerTabsType,
  MainTabsType,
  TransactionType,
  sortArrays,
} from './TransactionReport.model';
import TransactionReportFilter from './TransactionReportFilter';
import BulkTransactionList from './BulkTransactionList';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './TransactionReport.module.css';
import wordDoc from 'assets/icons/word_doc.svg';
import excelDoc from 'assets/icons/excel_doc.svg';
import pdfDoc from 'assets/icons/pdf_doc.svg';
import download from 'assets/img/download.png';
import noDataImg from 'assets/img/no_data_pending.png';

const TransactionReportMap: ITransactionReportMap[] = [
  {
    key: 'transfer',
    label: 'Transfers',
    path: 'transfer',
    filters: [
      { name: 'Between Own Accounts', code: 'OWN' },
      { name: 'To First Atlantic Bank', code: 'FAB' },
      { name: 'To Other Bank', code: 'OTHER' },
      { name: 'Bulk transfer', code: 'BULK' },
    ],
    getFilterCb: (filterCode) =>
      filterCode === 'FAB'
        ? ({ bankName }) => bankName === 'First Atlantic Bank'
        : ({ bankName }) => bankName !== 'First Atlantic Bank',
    getFieldsData: (ben, otherBank) => {
      const data = [{ label: 'Account Number', value: ben.accountNumber }];
      if (otherBank) {
        data.unshift({ label: 'Bank', value: ben.bankName });
      }
      return data;
    },
  },
  {
    key: 'mobilemoney',
    label: 'Mobile Money',
    path: 'mobilemoney',
    filters: [
      { name: 'Mobile Money Transfer', code: 'MMT' },
      { name: 'Mobile Money Bulk Transfer', code: 'MMBT' },
    ],
    getFilterCb:
      (filterCode) =>
      ({ networkCode }) =>
        networkCode === filterCode,
    getFieldsData: (ben) => [
      { label: 'Network', value: ben.networkCode },
      { label: 'Phone Number', value: ben.phoneNumber },
    ],
  },
  {
    key: 'prepaidcard',
    label: 'Prepaid Card',
    path: 'prepaidcard',
    filters: [
      { name: 'Single Card Load', code: 'SCL' },
      { name: 'Bulk Card Load', code: 'Bulk Card Load' },
    ],
    getFilterCb: () => identity,
    getFieldsData: (ben) => [
      { label: 'Customer ID', value: ben.cardCustomerId },
      { label: 'Card’s last 4 digits', value: ben.last4digit },
    ],
  },
  {
    key: 'billpayments',
    label: 'Bill Payments',
    path: 'billpayments',
    filters: [
      { name: 'Ghana GOV', code: 'GOV' },
      { name: 'SSNIT', code: 'SSNIT' },
    ],
    getFilterCb: () => identity,
    getFieldsData: (ben) => [
      { label: 'Customer ID', value: ben.cardCustomerId },
      { label: 'Card’s last 4 digits', value: ben.last4digit },
    ],
  },
  // {
  //   key: 'fxtransferrequest',
  //   label: 'FX Transfer Request',
  //   path: 'fxtransferrequest',
  //   filters: [],
  //   getFilterCb: () => identity,
  //   getFieldsData: (ben) => [
  //     { label: 'Customer ID', value: ben.cardCustomerId },
  //     { label: 'Card’s last 4 digits', value: ben.last4digit },
  //   ],
  // },
];

const mainTabsOptions = TransactionReportMap.map(({ label }) => ({ label }));

const innerTabsOptions = TransactionReportMap.map(({ filters }) => filters.map(({ name }) => ({ label: name })));

enum States {
  mainTable = 'mainTable',
  bulkTable = 'bulkTable',
}

const TransactionReport = () => {
  const [state, setState] = useState<States>(States.mainTable);
  const [activeMainTab, setActiveMainTab] = useState<MainTabsType>(0);
  // const [nextTab, setNextTab] = useState<MainTabsType>(0);
  const [activeInnerTab, setActiveInnerTab] = useState<InnerTabsType>(0);
  const [isFormDirty, setFormDirty] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const downMdScreen = useMediaQuery(useTheme().breakpoints.down('sm'));
  const [submitting, setSubmitting] = useState(false);
  const [filterApplied, setFilterApplied] = useState(false);
  const [filteredData, setFilterData] = useState<any>([]);
  const [isOpenTrxnDetailModal, setOpenTrxnDetailModal] = useState(false);
  const [confirmationData, setConfirmationData] = useState<ITransactionReport>();
  const [selectedAdvice, setSelectedAdvice] = useState<ITransactionField[]>([]);
  const [isPaymentAdviceOpen, setIsPaymnetAdviceOpen] = useState<boolean>(false);
  const [isDownloading, setIsDownloading] = useState<boolean>(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [searchParams, setSearchParams] = useState<ITransactionReportSearchParams>({});
  const [bulkDetail, setBulkDetail] = useState<any>({});

  const [transactionType, setTransactionType] = useState<TransactionType>(TransactionType.OWN_TRANSFER);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement | any>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const [anchorSecondEl, setSecondAnchorEl] = useState<null | HTMLElement | any>(null);
  const openMore = Boolean(anchorSecondEl);
  const handleClickMoreAnchor = (event: React.MouseEvent<HTMLButtonElement>) => {
    setSecondAnchorEl(event.currentTarget);
  };
  const emptyMessage = 'No Transaction Found';

  const closeTrxnDetailModal = () => {
    setOpenTrxnDetailModal(false);
  };

  const handleChangeMainTab = (_event: React.ChangeEvent<unknown>, tabIndex: MainTabsType) => {
    setFilterData([]);
    setFilterApplied(false);
    // setNextTab(tabIndex);
    setActiveMainTab(tabIndex);
    setActiveInnerTab(0);
  };

  const handleChangeInnerTab = (_event: React.ChangeEvent<unknown>, tabIndex: InnerTabsType) => {
    setFilterData([]);
    setFilterApplied(false);
    setActiveInnerTab(tabIndex);
  };

  const closeTableList = () => setState(States.mainTable);

  const openCategoryMenu = () => {
    setActiveMainTab(false);
  }; // mobile only

  const handleSetMobileTabs = (value) => {
    setActiveMainTab(value);
    setSecondAnchorEl(null);
  };

  const handleMoreClose = () => {
    setSecondAnchorEl(null);
  };

  const renderTitle = () => {
    if (activeMainTab === false) {
      return (
        <div>
          <h2 className={styles.categoryMenuTitle}>Transaction Report</h2>
        </div>
      );
    }

    return (
      <NavigationTitle to="/transactionReports" onClick={openCategoryMenu} layoutType={LayoutType.dashboard}>
        {downMdScreen ? (
          <div>
            {`Transaction Report: ${TransactionReportMap[activeMainTab].label}` }
            <Button
              type="button"
              className={styles.btnMore}
              theme={ButtonThemes.secondary}
              size={ButtonSizes.small}
              id="demo-positioned-button-category"
              aria-controls={openMore ? 'demo-positioned-menu-category' : undefined}
              aria-haspopup="true"
              aria-expanded={openMore ? 'true' : undefined}
              onClick={handleClickMoreAnchor}
            >
              <span className={styles.moreText}>Change Category</span>
            </Button>
            <Menu
              id="demo-positioned-menu-category"
              aria-labelledby="demo-positioned-button-category"
              anchorEl={anchorSecondEl}
              open={openMore}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
                style: { width: anchorSecondEl && anchorSecondEl.offsetWidth }, // <-- The line that does all
              }}
              PaperProps={{
                style: {
                  transform: 'translateX(0%) translateY(50%)',
                },
              }}
              onClose={handleMoreClose}
              keepMounted={false}
            >
              <MenuItem className={styles.tabItem} onClick={() => handleSetMobileTabs(0)}>
                Transfer
              </MenuItem>
              <MenuItem className={styles.tabItem} onClick={() => handleSetMobileTabs(1)}>
                Mobile Money
              </MenuItem>
              <MenuItem className={styles.tabItem} onClick={() => handleSetMobileTabs(2)}>
                Prepaid Card
              </MenuItem>
              <MenuItem className={styles.tabItem} onClick={() => handleSetMobileTabs(3)}>
                Bill Payment
              </MenuItem>
            </Menu>
          </div>
      )
        : 'Transaction Report'}
      </NavigationTitle>
    );
  };
  const renderIneerTabs = () => {
    if (activeMainTab === false || activeMainTab === 4) {
      return null;
    }

    return (
      <>
        <Tabs
          value={activeInnerTab}
          options={innerTabsOptions[activeMainTab]}
          onChange={handleChangeInnerTab}
          theme={downMdScreen ? 'primary' : 'secondary'}
          disableVertical
          variant="scrollable"
          scrollButtons="off"
          className={styles.innerTabs}
        />
      </>
    );
  };

  useEffect(() => {
    if (activeMainTab === 0) {
      switch (activeInnerTab) {
        case 1:
          setTransactionType(TransactionType.LOCAL_TRANSFER);
          break;
        case 2:
          setTransactionType(TransactionType.OTHERBANK_TRANSFER);
          break;
        case 3:
          setTransactionType(TransactionType.BULK_TRANSFER);
          break;
        default:
          setTransactionType(TransactionType.OWN_TRANSFER);
          break;
      }
    }

    if (activeMainTab === 1) {
      switch (activeInnerTab) {
        case 1:
          setTransactionType(TransactionType.MOBILE_MONEY_BULK);
          break;
        default:
          setTransactionType(TransactionType.MOBILE_MONEY_SINGLE);
          break;
      }
    }

    if (activeMainTab === 2) {
      switch (activeInnerTab) {
        case 1:
          setTransactionType(TransactionType.PREPAID_CARD_LOAD_BULK);
          break;
        default:
          setTransactionType(TransactionType.PREPAID_CARD_LOAD_SINGLE);
          break;
      }
    }

    if (activeMainTab === 3) {
      switch (activeInnerTab) {
        case 1:
          setTransactionType(TransactionType.BILLS_PAYMENT_SSNIT);
          break;
        default:
          setTransactionType(TransactionType.BILLS_PAYMENT_GHANA_GOV);
          break;
      }
    }

    if (activeMainTab === 4) {
      setTransactionType(TransactionType.FX);
    }
  }, [activeMainTab, activeInnerTab]);

  const getSelectedColumn = () => {
    const { defaultColumn, bulk, mobileMoney, prepaidCard, billsColumn, fxColumn } = allColumns;
    if (activeMainTab === 0) {
      if (activeInnerTab === 0 || activeInnerTab === 1) {
        return defaultColumn.filter((item) => item?.accessor !== 'beneficiaryBank' && item?.accessor !== 'totalAmount');
      }

      if (activeInnerTab === 2) {
        return defaultColumn.filter((item) => item?.accessor !== 'amount');
      }

      if (activeInnerTab === 3) {
        return bulk;
      }
    }

    if (activeMainTab === 1) {
      if (activeInnerTab === 0) {
        return mobileMoney.filter(
          (item) =>
            item?.accessor !== 'totalCount' &&
            item?.accessor !== 'bulkId' &&
            item?.accessor !== 'totalAmount' &&
            item?.accessor !== 'charge',
        );
      }

      if (activeInnerTab === 1) {
        const newList = mobileMoney;
        // newList[1] = {
        //   Header: 'Schedule ID',
        //   accessor: 'scheduleId',
        //   width: 120,
        // };
        return newList.filter(
          (item) =>
            item?.accessor !== 'beneficiaryName' &&
            item?.accessor !== 'txnMobileMoneyCode' &&
            item?.accessor !== 'beneficiaryAccount' &&
            item?.accessor !== 'amount' &&
            item?.accessor !== 'scheduleId' &&
            item?.accessor !== 'advice' &&
            item?.accessor !== 'elevy',
        );
      }
    }

    if (activeMainTab === 2) {
      if (activeInnerTab === 0) {
        return prepaidCard.filter((item) => item?.accessor !== 'cardName');
      }

      if (activeInnerTab === 1) {
        const newList = bulk;
        return newList.filter(
          (item) =>
            item?.accessor !== 'charge' &&
            item?.accessor !== 'beneficiaryName' &&
            item?.accessor !== 'amount' &&
            item?.accessor !== 'scheduleId' &&
            item?.accessor !== 'advice',
        );
      }
    }

    if (activeMainTab === 3) {
      if (activeInnerTab === 0) {
        return billsColumn.filter((item) => item?.accessor !== 'adviceNumber' && item?.accessor !== 'contributionType');
      }

      if (activeInnerTab === 1) {
        const newList = billsColumn;
        newList[0] = {
          Header: 'Schedule ID',
          accessor: 'scheduleId',
          width: 120,
        };
        return newList.filter(
          (item) =>
            item?.accessor !== 'invoiceNumber' && item?.accessor !== 'expiryDate' && item?.accessor !== 'service',
        );
      }
    }

    if (activeMainTab === 4) {
      return fxColumn;
    }

    return [];
  };

  const confirmationViewData = useMemo<ITransactionField[]>(
    () => getTransactionsArray({ ...confirmationData }),
    [confirmationData],
  );

  const handleCellClick = (cell: { row: { original: ITransactionReport }; column: { Header: string } }) => {
    if (cell?.column.Header === 'Bulk ID') {
      setBulkDetail({
        transactionType,
        bulkId: cell.row.original.bulkId,
      });
      setState(States.bulkTable);
    }

    if (activeMainTab === 1 && activeInnerTab === 0 && cell?.column.Header === 'Schedule ID') {
      setOpenTrxnDetailModal(true);
      setConfirmationData(cell.row.original);
    }

    if (
      (activeMainTab === 3 && cell?.column.Header === 'Schedule ID') ||
      (activeMainTab === 4 && activeInnerTab === 0 && cell?.column.Header === 'Request ID')
    ) {
      setOpenTrxnDetailModal(true);
      setConfirmationData(cell.row.original);
    }

    if (cell?.column.Header === 'Advice') {
      setIsPaymnetAdviceOpen(true);
      setConfirmationData(cell.row.original);

      const { sourceAccount,
        sourceAccountName,
        amount,
        beneficiaryAccount,
        beneficiaryName,
        narration,
        id,
        transactionDate,
        beneficiaryBank,
        scheduleId,
         } = cell.row.original;

      const readyValues = {
        sourceAccount: Number(sourceAccount),
        sourceAccountName,
        amount,
        beneficiaryAccount,
        beneficiaryName,
        narration,
        id,
        scheduleId,
        transactionDate,
        beneficiaryBank,
        transactionType: cell.row.original.transactionType,
      };
      setSelectedAdvice(getTransactionsArray(readyValues, undefined, undefined, sortArrays));
    }
  };

  const onSubmit = (values: ITransactionReportSearchParams) => {
    setFilterData([]);
    setSubmitting(true);
    setFilterApplied(true);
    setSearchParams(values);
    const requestBody = {
      ...values,
      transactionType,
      pageNumber,
      pageSize,
    };
    const url = transactionType.includes('BULK') ? '/transaction-reports/fetchBulk' : '/transaction-reports/fetch';
    api
      .post(url, requestBody)
      .then((data: IApiTransactionReport) => {
        setSubmitting(false);
        if (transactionType.includes('BULK')) {
          setTotalRows(data.count);
          setFilterData(data?.transactions);
        } else {
          setTotalRows(data.count);
          setFilterData(data?.transfers);
        }
      })
      .catch((error: IApiResponse) => {
        console.error(error.description);
        setSubmitting(false);
      });
  };

  useEffect(() => {
    onSubmit(searchParams);
  }, [pageNumber, pageSize]);

  const handlePageChange = (_: React.ChangeEvent<unknown>, newPage: number) => {
    setPageNumber(newPage);
  };

  const handlePageSizeChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newPageSize = parseInt(event.target.value as string, 10);
    setPageSize(newPageSize);
    setPageNumber(1);
  };

  const closePaymentAdvice = () => {
    setIsPaymnetAdviceOpen(false);
  };

  const handleDownloadAdvice = (type: string) => {
    setSubmitting(true);

    const requestBody = {
      transactionId: confirmationData?.id,
      reportType: type?.toLocaleUpperCase(),
    };
    api
      .post('/transaction-reports/download-payment-advice', requestBody, true, false, 'arraybuffer')
      .then((data: string) => {
        saveByteArray(data, type, `${confirmationData?.beneficiaryName || 'Payment_Advice'}`);
        setSubmitting(false);
      })
      .catch((error: IApiResponse) => {
        console.error(error.description);
        setSubmitting(false);
      });
  };


  const handleDownloadReport = (type: string) => {
    setIsDownloading(true);

    const requestBody = {
      ...searchParams,
      transactionType,
      downloadType: type?.toLocaleUpperCase(),
    };
    api
      .post('/transaction-reports/download', requestBody, true, false, 'arraybuffer')
      .then((data: string) => {
        saveByteArray(data, type, `${confirmationData?.beneficiaryName || 'PDF_report'}`);
        setIsDownloading(false);
      })
      .catch((error: IApiResponse) => {
        console.error(error.description);
        setIsDownloading(false);
      });
  };

  const handleClose = (type: string) => {
    setAnchorEl(null);
    if (typeof type === 'string') {
      handleDownloadReport(type);
    }
  };

  const renderPreviewList = () => {
    if (activeMainTab === false) {
      return null;
    }

    if (submitting) {
      return (
        <div className={styles.m25}>
          <Loader />
        </div>
      );
    }

    if (filterApplied && (filteredData?.length === 0 || filteredData === null)) {
      return (
        <>
          <div className={styles.nodata} />
          <NoData
            img={noDataImg}
            title="No transactions found"
            subtitle="No results for your filters were found. Kindly try other filers."
          />
        </>
      );
    }

    return (
      <div className={styles.preview}>
        {filterApplied ? (
          <div>
            {filteredData?.length > 0 && (
              <div>
                {filteredData?.length > 0 && (
                  <div>
                    <Button
                      type="button"
                      className={styles.btnSubmit}
                      theme={ButtonThemes.secondary}
                      size={ButtonSizes.small}
                      id="demo-positioned-button"
                      aria-controls={open ? 'demo-positioned-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? 'true' : undefined}
                      onClick={handleClick}
                    >
                      {isDownloading ?
                        <CircularProgress size={20} color="inherit" />
                        : (
                          <>
                            <img src={download} alt="delete icon" />
                            <span className={styles.downloadText}>Download</span>
                          </>
                      )}

                    </Button>
                    <Menu
                      id="demo-positioned-menu"
                      aria-labelledby="demo-positioned-button"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                        style: { width: anchorEl && anchorEl.offsetWidth }, // <-- The line that does all
                      }}
                      PaperProps={{
                        style: {
                          transform: 'translateX(0%) translateY(50%)',
                        },
                      }}
                      keepMounted={false}
                    >
                      <MenuItem onClick={() => handleClose('excel')}>
                        <img src={excelDoc} alt="excel icon" className={styles.downloadIcon} />
                        Excel
                      </MenuItem>
                      <MenuItem onClick={() => handleClose('pdf')}>
                        <img src={pdfDoc} alt="pdf icon" className={styles.downloadIcon} />
                        PDF
                      </MenuItem>
                      <MenuItem onClick={() => handleClose('word')}>
                        <img src={wordDoc} alt="word icon" className={styles.downloadIcon} />
                        Word
                      </MenuItem>
                    </Menu>
                    <div className={styles.tableWrapper}>
                      <Table
                        columns={getSelectedColumn()}
                        data={filteredData}
                        getCellValue={handleCellClick}
                        emptyTableMessage={emptyMessage}
                      />
                    </div>
                    <TablePagination
                      count={Math.ceil(totalRows / pageSize)}
                      page={pageNumber}
                      pageSize={pageSize}
                      totalCount={totalRows}
                      handlePageChange={handlePageChange}
                      handlePageSizeChange={handlePageSizeChange}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        ) : (
          <div className={styles.applyFilter}>Apply Filters to generate report</div>
        )}
      </div>
    );
  };

  if (state === States.bulkTable) {
    return <BulkTransactionList onClose={closeTableList} bulkDetail={bulkDetail} activeTab={activeMainTab} />;
  }
  // const onLeavePage = () => {
  //   setShowWarning(false);
  //   setFormDirty(false);
  //   if (downMdScreen) {
  //     setActiveMainTab(false);
  //   } else {
  //     setActiveMainTab(nextTab);
  //   }
  // };
    const handleClickBack = () => {
    if (isFormDirty) {
      setShowWarning(true);
    } else {
      setActiveMainTab(false);
    }
  };

  const closeWarning = () => setShowWarning(false);
  return (
    <>
      <DashboardCard fullHeight className={styles.positionRelative}>
        {/* <NavigationTitle
          to="/transactionReports"
          layoutType={LayoutType.dashboard}
          onClick={handleClickBack}
          noArrow={activeInnerTab === false}
        >
          {activeInnerTab === false || !downMdScreen ? '' : mainTabsOptions[activeInnerTab].label}
        </NavigationTitle> */}
        {renderTitle()}
        {downMdScreen && activeMainTab === false && <MobileSubtitle>Select category</MobileSubtitle>}
        <Tabs value={activeMainTab} options={mainTabsOptions} onChange={handleChangeMainTab} />
        {renderIneerTabs()}
        <div className={styles.mt40}>
          <TransactionReportFilter
            submitting={submitting}
            onSubmitFilters={onSubmit}
            activeMainTab={activeMainTab}
            activeInnerTab={activeInnerTab}
            transactionType={transactionType}
          />
        </div>
        {renderPreviewList()}
        <TransactionDetails data={confirmationViewData} open={isOpenTrxnDetailModal} onClose={closeTrxnDetailModal} />
        {/* <WarningModal open={showWarning} submitName="Leave Page" onSubmit={onLeavePage} onClose={closeWarning}>
          Entered data will be lost. Are you sure you want to leave page?
        </WarningModal> */}
      </DashboardCard>
      <PaymentAdviceModal
        open={isPaymentAdviceOpen}
        onClose={closePaymentAdvice}
        data={selectedAdvice}
        onSubmit={handleDownloadAdvice}
        submitting={submitting}
      />
    </>
  );
};

export default TransactionReport;
